export default "__VITE_ASSET__Vw3RN5OX__"